import { FormContextValues } from '@dreryk/react-common';

import { AppointmentForm } from '../../shared/form/AppointmentForm';
import { AppointmentFormBean } from '../../shared/form/AppointmentForm.types';

export type AppointmentUpdateFormBean = AppointmentFormBean;
export type AppointmentUpdateFormController = FormContextValues<AppointmentUpdateFormBean>;

export const AppointmentUpdateForm = AppointmentForm;
